<template>
  <span class="new-badge" :class="getClass()">Beta</span>
</template>

<script lang="ts" setup>
interface Props {
  size?: 'regular' | 'large';
}

const props = withDefaults(defineProps<Props>(), { size: 'regular' });

const getClass = () => {
  const toReturn: any = {};
  toReturn[props.size] = true;

  return toReturn;
};
</script>

<style scoped>
.new-badge {
  @apply bg-orange-500 text-white border border-white dark:border-zinc-900 font-bold uppercase;
}
.new-badge.regular {
  @apply px-0.5 py-px rounded;
  font-size: 0.4375rem;
}
.new-badge.large {
  @apply px-1 py-0.5 rounded-md;
  font-size: 0.625rem;
}
</style>
